import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { ITreatmentReport, ITreatmentReportTreatment, ITreatmentReportEpiReport } from "../models/ITreatmentReport";

export class TreatmentReportApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getTreatmentReport(id: string, success: (data: ITreatmentReport) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ITreatmentReport>(`${Utils.LIB_API_BASE_URL}/treatmentReport/${id}`, success, error, final);
    }

    getTreatment(id: number, success: (data: ITreatmentReportTreatment) => void, error?: (message: string) => void) {
        this.get<ITreatmentReportTreatment>(`${Utils.LIB_API_BASE_URL}/treatmentReport/treatment/${id}`, success, error);
    }

    getTreatmentCodes(patientId: number, carePerformerId: number, treatmentDate: string, success: (data: ITreatmentReportTreatment[]) => void, error?: (message: string) => void) {
        this.get<ITreatmentReportTreatment[]>(`${Utils.LIB_API_BASE_URL}/treatmentReport/patient/${patientId}/${carePerformerId}/${treatmentDate}/treatmentCodes`, success, error);
    }

    createTreatmentReport(patientId: number, success: (treatmentReportId: number) => void, error?: (message: string) => void) {
        this.postWithResponse<number>(`${Utils.LIB_API_BASE_URL}/treatmentReport/${patientId}`, null, success, error);
    }

    closeTreatmentReport(id: string, success: () => void, error?: (message: string) => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/treatmentReport/closeTreatmentReport/${id}`, null, success, error);
    }

    addTreatment(treatment: ITreatmentReportTreatment, success: () => void, error?: (message: string) => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/treatmentReport/addTreatment`, treatment, success, error);
    }

    deleteTreatment(patientTreatmentId: number, success: () => void, error?: (message: string) => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/treatmentReport/treatment/${patientTreatmentId}`, success, error);
    }

    createEpiReport(epiReport: ITreatmentReportEpiReport, success: () => void, error?: (message: string) => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/treatmentReport/addEpiReport`, epiReport, success, error);
    }

    deleteEpiReport(id: number, success: () => void, error?: (message: string) => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/treatmentReport/epiReport/${id}`, success, error);
    }

    getEpiReportTypeId(patientId: number, assessmentDate: string, success: (data: number) => void, error?: (message: string) => void) {
        this.get<number>(`${Utils.LIB_API_BASE_URL}/treatmentReport/epiReportTypeId/${assessmentDate}/${patientId}`, success, error);
    }
}